import { CallCenterConnectionStatusType } from './types';

export const UNKNOWN_PHONE_NUMBER = 'UNKNOWN';

export const PENDING_CONNECTION_STATUS: CallCenterConnectionStatusType[] = ['ANSWERING', 'CALLING'];

export const OUTBOUND_CONNECTION_STATUS: CallCenterConnectionStatusType[] = ['CALL_PENDING', 'CALLING'];
